export interface ColumnProps {
    width?: "5%" | "10%" | "15%" | "20%" | "25%";
}

export const defaultColumnProps = {
    width: undefined
}